export default __webpack_public_path__ + "static/media/spouse.931d37cd.svg";